import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ClarityModule } from '@clr/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { Router } from '@angular/router';
import { ComposeMessageComponent } from './compose-message.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { RegisterComponent } from './register.component';
import { PageNotFoundComponent } from './not-found.component';
import { CoreModule } from './core/core.module';

import {
  AuthServiceConfig,
  GoogleLoginProvider,
  SocialLoginModule
} from 'angularx-social-login';
import { HomeComponent } from './public/home.component';
import { SharedModule } from './shared/shared.module';
import { UnauthorisedComponent } from './unauthorised.component';
import { CustomerComponent } from './public/customer.component';
import { AgmCoreModule } from '@agm/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
// import {FullCalendarModule} from '@fullcalendar/angular';

const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(
      '585826692084-1gor3gii55h979f64foutbotintqcihi.apps.googleusercontent.com'
    )
  }
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    ComposeMessageComponent,
    LoginComponent,
    RegisterComponent,
    PageNotFoundComponent,
    UnauthorisedComponent,
    HomeComponent,
    CustomerComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    // FullCalendarModule,
    ReactiveFormsModule,
    HttpClientModule,
    ClarityModule,
    LoginRoutingModule,
    CoreModule,
    SocialLoginModule,
    AppRoutingModule,
    SharedModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB_09Dpdr1vVXA7J0y8mUkKRdr0ndUm1Gg',
      libraries: ['places']
    }),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory })
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor(router: Router) {
    // console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
  }
}
